import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { GroupMemberChangeablePermissions } from '@weblite/ts-action/subscription'
import {
  changeGroupPermissions,
  getGroupChangeablePermission,
} from '$logic/hall'
import {
  GROUP_MEMBER_PERMISSIONS,
  HallPermissionsPage,
} from '$common/hall-permissions-page'
import { t } from '$i18n'
import { useAsyncFunction } from '$func/async-function.react-hook'
import {
  closeChannelAdminPermissions,
  closeGroupMemberPermissions,
  openGroupExceptions,
} from '$logic/router'
import { showSaveChangesLoadingModal } from '$comp/modals/loading-modal'
import { useClientUserPermissions } from '$logic/subscription/react-hook'

interface Props {
  roomId: string
}

export function GroupMemberPermissions({ roomId }: Props) {
  const { value: initialPermissions } = useAsyncFunction<
    GroupMemberChangeablePermissions
  >(() => getGroupChangeablePermission(roomId), [roomId])

  const clientPermissions = useClientUserPermissions(roomId)
  const canEditMembersPermissions = clientPermissions?.banUsers

  const onComplete = async (permissions: GroupMemberChangeablePermissions) => {
    showSaveChangesLoadingModal()
    await changeGroupPermissions(roomId, permissions)
    await closeCurrentModal()
    await closeChannelAdminPermissions()
  }

  return (
    <HallPermissionsPage
      pageTitle={t('hallPermissionsPage.groupMemberPermissions.title')}
      subTitle={t('hallPermissionsPage.groupMemberPermissions.subTitle')}
      confirmDisabled={false}
      rights={GROUP_MEMBER_PERMISSIONS.map(permission => ({
        ...permission,
        isLocked: !clientPermissions?.[permission.id],
      }))}
      actionButtonProps={
        canEditMembersPermissions
          ? {
              text: t(
                'hallPermissionsPage.groupMemberPermissions.actionButtonText',
              ),
              color: 'secondary',
            }
          : undefined
      }
      userId={null}
      initialPermissions={initialPermissions}
      onBack={closeGroupMemberPermissions}
      onComplete={onComplete}
      onActionButtonClick={
        canEditMembersPermissions ? () => openGroupExceptions(roomId) : null
      }
    />
  )
}
